import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { holdingCompanyService } from '../../../api';
import { PaginatedRequest } from '../../../types/api';
import { CreateHoldingCompanyRequest, UpdateHoldingCompanyRequest } from '../../../types/holdingCompany';

export const fetchHoldingCompanies = createAsyncThunk('holdingCompany/fetch-all', (data: PaginatedRequest) =>
  holdingCompanyService.fetchHoldingCompanies(data),
);

export const fetchHoldingCompany = createAsyncThunk('holdingCompany/get', (id: number) =>
  holdingCompanyService.fetchHoldingCompany(id),
);

export const deleteHoldingCompany = createAsyncThunk('holdingCompany/delete', (id: number) =>
  holdingCompanyService.deleteHoldingCompany(id),
);

export const createHoldingCompany = createAsyncThunk(
  'holdingCompany/create',
  (holdingCompany: CreateHoldingCompanyRequest) => holdingCompanyService.createHoldingCompany(holdingCompany),
);

export const updateHoldingCompany = createAsyncThunk(
  'holdingCompany/update',
  (holdingCompany: UpdateHoldingCompanyRequest) => holdingCompanyService.updateHoldingCompany(holdingCompany),
);

export const resetEditHoldingCompany = createAction('holdingCompany/reset-edit');

export const cleanHoldingCompanies = createAction('holdingCompany/clean');
